import React from "react";
import { useTranslation } from "react-i18next";
import { ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
    StyledButton,
    StyledIconButton,
    StyledModal,
    CrossIcon,
} from "@aureskonnect/react-ui";
import PageTitle from "@components/Common/PageTitle";
import { getTransactionsTransfers } from "./helpers";
import { CustomFooter } from "./CustomFooter";

import "./styles.css";
import NoDataOverlay from "./NoDataOverlay";

type ListTransactionsConnecsModalType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    transactionsids: string;
};

type TransactionRow = {
    id: number;
    date: string;
    typeconecs: string;
    typetransaction: string;
    montant: string;
};

export function TransactionsConnecsModal({
    isModalOpened,
    setIsModalOpened,
    transactionsids,
}: ListTransactionsConnecsModalType) {
    const { t } = useTranslation();
    const [rows, setRows] = React.useState<TransactionRow[]>([]);
    const [currentPage, setCurrentPage] = React.useState(0);
    const pageSize = 10;
    const totalPages = Math.ceil(rows.length / pageSize);
    const customHeader = "custom-header";
    const columns: GridColDef[] = [
        {
            field: "date",
            headerName: "Date",
            flex: 1,
            headerClassName: customHeader,
            minWidth: 150,
        },
        {
            field: "typeconecs",
            headerName: "Type Conecs",
            flex: 2,
            headerClassName: customHeader,
            minWidth: 150,
        },
        {
            field: "typetransaction",
            headerName: "Type Transaction",
            flex: 1,
            headerClassName: customHeader,
            minWidth: 150,
        },
        {
            field: "montant",
            headerName: "Montant",
            flex: 1,
            headerClassName: customHeader,
            minWidth: 150,
        },
    ];

    const handlePageChange = (newPage: number) => {
        if (newPage >= 0 && newPage < totalPages) {
            setCurrentPage(newPage);
        }
    };

    React.useEffect(() => {
        const loadRows = async () => {
            const fetchedRows = await getTransactionsTransfers(transactionsids);
            setRows(fetchedRows);
        };
        loadRows();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [transactionsids, isModalOpened]);

    return (
        <div>
            <PageTitle title="Transactions conecs SoftaveraPay" />
            <StyledModal
                className="transactions-modal-style"
                isOpen={isModalOpened}
            >
                {" "}
                {/* Use isModalOpened here */}
                <ModalHeader className="d-flex align-items-center">
                    <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ height: "35px", gap: "1260px" }}
                    >
                        <span className="title-modal-style__clz">
                            {t("TRANSACTIONS")}
                        </span>
                        <StyledIconButton
                            icon="CrossIcon"
                            onClick={() => setIsModalOpened(false)}
                        >
                            <CrossIcon
                                cursor="pointer"
                                height={10}
                                width={10}
                            />
                        </StyledIconButton>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <fieldset
                        className="p-3 title-legend-style"
                        style={{ width: "100%", height: "615px" }}
                    >
                        <div style={{ height: "590px", width: "100%" }}>
                            <DataGrid
                                rows={rows.slice(
                                    currentPage * pageSize,
                                    (currentPage + 1) * pageSize
                                )}
                                columns={columns}
                                disableSelectionOnClick
                                components={{
                                    NoRowsOverlay: NoDataOverlay,
                                    Footer: CustomFooter, 
                                }}
                                componentsProps={{
                                  noRowsOverlay: NoDataOverlay,
                                    footer: {
                                        currentPage,
                                        onPageChange: handlePageChange,
                                        totalPages,
                                    },
                                }}
                            />
                        </div>
                    </fieldset>
                </ModalBody>
                <ModalFooter className="d-flex justify-content-end">
                    <StyledButton
                        className="cmn_btn_cancel"
                        variant="light"
                        outline
                        size="sm"
                        onClick={() => setIsModalOpened(false)}
                    >
                        {t("Close")}
                    </StyledButton>
                </ModalFooter>
            </StyledModal>
        </div>
    );
}
